import { Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

const PrivateRoute = ({ children }) => {
  const { user, authChecked } = useAuth();

  if (!authChecked) {
    // Auth status is loading — optionally render loading spinner or null
    return <div>Loading...</div>;
  }

  if (!user) {
    console.error('User is not authenticated.');
    return <Navigate to="/iam/login" replace />;
  }

  return children;
};

export default PrivateRoute;
